import { defineStore } from "pinia";

export const useHighlightStore = defineStore("highlight", {
  state: () => {
    const keys: Record<number, Record<number, boolean>> = {};
    const layers: Record<number, boolean> = {};
    return {
      keys,
      layers,
    };
  },

  getters: {
    isHighlightedKey(state): (row: number, col: number) => boolean {
      return (row, col) => state.keys[row] && state.keys[row][col];
    },

    isHighlightedLayer(state): (layer: number) => boolean {
      return (layer) => state.layers[layer];
    },
  },

  actions: {
    setHighlightedKey(row: number, col: number, duration: number) {
      if (this.keys[row] == undefined) this.keys[row] = {};
      this.keys[row][col] = true;
      setTimeout(() => (this.keys[row][col] = false), duration);
    },

    // Like setHighlightedKey but ensure that highlight time is the same for all keys
    setHighlightedKeys(positions: [number, number][], duration: number) {
      this.$patch((state) => {
        for (const [row, col] of positions) {
          if (state.keys[row] == undefined) state.keys[row] = {};
          state.keys[row][col] = true;
        }
      });

      setTimeout(() => {
        this.$patch((state) => {
          for (const [row, col] of positions) {
            state.keys[row][col] = false;
          }
        });
      }, duration);
    },

    setHighlightedLayer(layer: number, duration: number) {
      this.layers[layer] = true;
      setTimeout(() => (this.layers[layer] = false), duration);
    },
  },
});
